export { ModalTitle } from "./ModalTitle";
export { ModalDescription } from "./ModalDescription";
export { isFromModal } from "./utils";
export { ModalContent } from "./ModalContent";
export {
	Modal,
	ModalTrigger,
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalClose,
} from "ics-ui-kit/components/modal";
